import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { Locale } from '@/enumerations/Locale';
import { getLocaleFromLS } from '@/modules/LocaleStorage';

import enLocale from 'element-ui/lib/locale/lang/en';
import ruLocale from 'element-ui/lib/locale/lang/ru-RU';
import ukLocale from 'element-ui/lib/locale/lang/ua';

import enMessages from '@/locales/en.json';
import ruMessages from '@/locales/ru.json';
import ukMessages from '@/locales/uk.json';

const allMessages = {
  [Locale.En]: { ...enLocale, ...enMessages },
  [Locale.Ru]: { ...ruLocale, ...ruMessages },
  [Locale.Uk]: { ...ukLocale, ...ukMessages },
};

const appDataAvailableLanguages = window.APP_DATA.preferences.locales;

const messages = { ...allMessages };

const LS_LOCALE = getLocaleFromLS();

let fallbackLocale = Locale.En as string;
let locale = window.APP_DATA.language || LS_LOCALE;

if (
  appDataAvailableLanguages.length &&
  Object.keys(allMessages).some(lang => appDataAvailableLanguages.includes(lang))
) {
  Object.keys(allMessages).forEach(lang => {
    if (!appDataAvailableLanguages.includes(lang)) {
      delete (messages as any)[lang];
    }
  });

  if (!appDataAvailableLanguages.includes(fallbackLocale)) {
    fallbackLocale = appDataAvailableLanguages[0];
  }

  if (!appDataAvailableLanguages.includes(locale)) {
    locale = appDataAvailableLanguages[0];
  }
}

Vue.use(VueI18n);

export const languages = Object.keys(messages);

export default new VueI18n({
  silentTranslationWarn: true,
  locale,
  fallbackLocale,
  messages,
});
